"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _rcSlider = _interopRequireDefault(require("rc-slider"));
var RatioSliderRow = function RatioSliderRow(_ref) {
  var gender = _ref.gender,
    min = _ref.min,
    max = _ref.max,
    value = _ref.value,
    onSliderChange = _ref.onSliderChange,
    icon = _ref.icon;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, gender), /*#__PURE__*/_react["default"].createElement("img", {
    className: "ratio-icon m-l-xs",
    src: icon,
    alt: gender
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row ratio-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-10"
  }, /*#__PURE__*/_react["default"].createElement(_rcSlider["default"], {
    min: min,
    max: max,
    step: 1,
    value: value,
    onChange: function onChange(value) {
      return onSliderChange(value, gender);
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-2"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "ratio-value"
  }, value))));
};
RatioSliderRow.propTypes = {
  gender: _propTypes["default"].string,
  min: _propTypes["default"].number,
  max: _propTypes["default"].number,
  value: _propTypes["default"].number,
  icon: _propTypes["default"].string,
  onSliderChange: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = RatioSliderRow;